(function () {
  function buildThumbs(gallery) {
    if (gallery.querySelector('.aviiro-sticky-thumbs')) return;

    var list = gallery.querySelector('.media-gallery__grid');
    if (!list) return;

    var items = Array.from(list.children);
    if (items.length < 2) return;

    var rail = document.createElement('div');
    rail.className = 'aviiro-sticky-thumbs';
    rail.setAttribute('aria-label', 'Product images');

    var buttons = items.map(function (item, index) {
      var img = item.querySelector('img');
      if (!img) return null;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'aviiro-sticky-thumbs__btn';
      if (index === 0) button.classList.add('is-active');
      button.setAttribute('aria-label', 'Show image ' + (index + 1));

      var thumbImg = document.createElement('img');
      thumbImg.src = img.currentSrc || img.src;
      thumbImg.alt = '';
      thumbImg.loading = 'lazy';
      button.appendChild(thumbImg);

      button.addEventListener('click', function () {
        item.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      rail.appendChild(button);
      return button;
    });

    gallery.insertBefore(rail, list);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var index = items.indexOf(entry.target);
          var button = buttons[index];
          if (!button) return;
          if (entry.isIntersecting) {
            buttons.forEach(function (b) {
              if (b) b.classList.remove('is-active');
            });
            button.classList.add('is-active');
          }
        });
      },
      { threshold: 0.5 }
    );

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function init() {
    var gallery = document.querySelector('[id$="__main"] media-gallery.media-gallery--grid');
    if (gallery) buildThumbs(gallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
